module.exports = __webpack_public_path__ + "img/jdb_logo.1afa48e8.gif";